import React from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
function LogOut() {
  const navigate = useNavigate();

  function handleLogout() {
    AuthService.performLogout(navigate);
  }

  return (
    <div>
      <h2 className="text-dark ">Are you sure you want to logout?
      </h2>
          <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default LogOut;